module.exports = __webpack_public_path__ + "static/assets/b248aa1aa8d81580409e71c8556b353c.svg";